var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stembus",class:_vm.fadeClasses},[_c('img',{staticClass:"image",attrs:{"src":require('@/assets/images/stemhok.gif'),"alt":"","draggable":"false"}}),_c('div',{staticClass:"men",style:({
      'background-image': ("url(" + (require('@/assets/images/group-of-men.svg')) + ")")
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }